import couponImage from "@/assets/images/common/coupon.png"
import FormError from "@/components/FormError"
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { useNewsletter } from "@/hooks/Newsletter/useNewsletter"
import { cn } from "@/lib/utils"
import { zodResolver } from "@hookform/resolvers/zod"
import { Modal } from "antd"
import Image from "next/image"
import { useEffect } from "react"
import { useForm } from "react-hook-form"
import { useIntl } from "react-intl"
import { z } from "zod"

export const Newsletter = ({ className }: { className?: string }) => {
  const { formatMessage } = useIntl()
  const {
    errors,
    handleSubmit,
    isBusy,
    newsLetterResponse,
    isModalOpen,
    setIsModalOpen,
  } = useNewsletter()

  const FormSchema = z.object({
    email: z.string().email(),
  })

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema as any),
    defaultValues: {
      email: "",
    },
  })

  const onButtonClick = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    if (newsLetterResponse && newsLetterResponse.status) {
      setIsModalOpen(true)
    }
  }, [formatMessage, newsLetterResponse, setIsModalOpen])

  return (
    <div data-cy={"Newsletter-root"} className={cn("mt-[30px]", className)}>
      <div
        data-cy="Newsletter-title"
        className="text-center font-poppins text-[18px] font-[600] leading-[1.4] lg_text-left lg_text-[22px]"
      >
        SUBSCRIBE NOW AND GET 10% OFF
      </div>
      <FormError allowErrorMessages errors={Array.from(errors.values())} />
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(handleSubmit)}
          className="mt-[15px] flex h-[50px] w-full"
        >
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <Input
                    placeholder="Enter your email address..."
                    className="w-full rounded-l-[5px] border-none bg-white text-primary focus_border-none"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <button
            type="submit"
            disabled={isBusy}
            className="h-full w-[111px] rounded-r-[5px] bg-[#a1c323] hover_bg-[#a1c323]"
          >
            {isBusy ? "SUBSCRIBING..." : "SUBSCRIBE"}
          </button>
        </form>
      </Form>
      <Modal
        open={isModalOpen}
        title={null}
        footer={null}
        width={800}
        onCancel={() => setIsModalOpen(false)}
      >
        <div className="flex flex-col items-center">
          <h2 className="mt-[45px] font-poppins text-[24px] uppercase leading-[30px] text-primary">
            thank you for subscribing!
          </h2>
          <p className="mt-2.5 font-sans text-[18px] font-semibold leading-[30px] text-paragraph">
            you just got a
          </p>
          <Image
            src={couponImage}
            className="mt-5 h-auto w-[443px]"
            alt="coupon"
          />
          <p
            className="mt-[50px] cursor-pointer bg-primary px-[56px] font-poppins uppercase leading-[60px] text-white"
            onClick={onButtonClick}
          >
            Shop now
          </p>
        </div>
      </Modal>
    </div>
  )
}
